if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.bindAtcButtons();

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      bindAtcButtons() {
        this.querySelectorAll('form[data-type="add-to-cart-form"] button[type="submit"]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const form = btn.closest('form');
            if (!form || btn.disabled) return;

            const variantInput = form.querySelector('[name="id"]');
            if (!variantInput || !variantInput.value) return;

            btn.setAttribute('aria-disabled', 'true');
            btn.classList.add('btn--loading');

            fetch(FoxTheme.routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 })
            })
            .then(r => r.json())
            .then(data => {
              if (data.status && data.status !== 200) return;

              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: data } }));

              return fetch(FoxTheme.routes.cart_url, { headers: { 'Accept': 'application/json' } })
                .then(r => r.json())
                .then(cartJson => {
                  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
                });
            })
            .catch(err => console.error(err))
            .finally(() => {
              btn.removeAttribute('aria-disabled');
              btn.classList.remove('btn--loading');
            });
          });
        });
      }
    }
  );
}
